import { RootState } from '../types'

export const getMainOrderSelector = (state: RootState) => state.order
export const getOrdersSelector = (state: RootState) => state.order.orders
